<template>
  <div id="register" class="mt-5 px-4">
    <div class="row">
      <div class="col-xl-4 col-lg-4 offset-xl-4 offset-lg-4">
        <div class="cotizarlo-general-wrapper">
          <div class="card-body px-5 py-4">
            <form>
              <div class="row">
                <div class="col-12">
                  <h6 class="subtitle-section mb-0">Crear nuevo usuario</h6>
                </div>
              </div>
              <!-- Campos de formulario -->
              <div class="row mt-4">
                <div class="col">
                  <div class="form-group">
                    <div class="input-icon-container">
                      <input type="email" placeholder="Usuario / e-mail" :class="{ 'is-invalid': $v.normal_register.email.$error }" id="email" v-model="normal_register.email" autocomplete="new_email"/>
                      <i class="fa fa-user icon" aria-hidden="true"></i>
                    </div>
                    <small class="form-text text-danger mt-1" v-show="!$v.normal_register.email.email">Ingresa un email válido.</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <div class="input-icon-container">
                      <input type="text" :class="{ 'is-invalid': $v.normal_register.name.$error }" class="no-icon" id="name" v-model="normal_register.name" placeholder="Nombre" autocomplete="new_name" />
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <div class="input-icon-container">
                      <input type="text" :class="{ 'is-invalid': $v.normal_register.last_name.$error }" class="no-icon" id="last_name" v-model="normal_register.last_name" placeholder="Apellidos" autocomplete="new_last_name" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <div class="input-icon-container">
                      <input type="password" :class="{ 'is-invalid': $v.normal_register.password.$error }" id="password" v-model="normal_register.password" placeholder="Contraseña" autocomplete="new_password" />
                      <i class="fa fa-lock icon" aria-hidden="true"></i>
                    </div>
                    <small class="form-text text-danger" v-show="!$v.normal_register.password.minLength">La contraseña debe ser de al menos 6 caractéres</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <div class="input-icon-container">
                      <input type="text" :class="{ 'is-invalid': $v.normal_register.company.$error }" id="company" v-model="normal_register.company" placeholder="Nombre de empresa" autocomplete="new_company" />
                      <i class="fa fa-building icon" aria-hidden="true"></i>
                    </div>
                    <!-- <small class="form-text text-danger" v-show="$v.normal_register.password.minLength">No coincide la contraseña</small> -->
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <button type="submit" class="btn form-control cot-login-btn" @click.prevent="register">Crear cuenta</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import methods from '@/mixins/methods'
import { validationMixin } from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators';

export class SocialLoginResponse {
    isNewUser = false;
    image = null;
    birthdate = null;
    name = null;
    socialId = null;
    email = null;
    provider = null;
}

export default {
  mixins: [ validationMixin, methods ],
  data() {
    return {
      normal_register:{
        name: null,
        last_name: null,
        email: null,
        password: null,
        company:"",
      },
    }
  },

  validations: {
    normal_register:{
      name: { required },
      last_name: { required },
      company: { required },
      email: { required, email },
      password: { required, minLength: minLength(6) },
    },
  },

  methods: {
    register() {
      this.$v.normal_register.$touch()
      if (this.$v.normal_register.$invalid) {
        this.$store.dispatch("showMessage", {
          action: "error",
          message: "Por favor revisa todos los campos",
        });
      }else{
        this.$store.dispatch('showLoader',{show:true});
        this.$store.dispatch("admin/createUser", this.$data.normal_register).then(
          () => {
            this.$store.dispatch('showLoader',{show:false});
            this.$store.dispatch('showMessage',{
              action:'success',
              message:'El usuario ha sido agregado correctamente'
            });
            this.$router.push({name: 'adminDashboard'});
          }
        ).catch(
          ()=>{
            this.$store.dispatch('showLoader',{show:false});
          }
        )
      }
    },
  }
}
</script>
